import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const getBaseUrl = () => {
  if (typeof window === 'undefined') return '/api/';
  const port = process.env.REACT_APP_DEV_API_SERVER_PORT;
  if (process.env.NODE_ENV === 'development' && port) {
    return `http://localhost:${port}/api/`;
  }
  return '/api/';
};

/**
 * RTK Query API for account-level reads/mutations that don't fit the
 * per-form ducks. Currently exposes:
 *
 *   useGetAccountEmailQuery(): the address Supabase holds for the member and
 *                               any pending change. Supabase is authoritative
 *                               for the address, so the UI reads this rather
 *                               than the Sharetribe currentUser, whose copy is
 *                               updated in the background and can lag. Cached
 *                               via the 'AccountEmail' tag so saveEmail /
 *                               resendEmailChange flows can invalidate it.
 */
export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: fetchBaseQuery({ baseUrl: getBaseUrl(), credentials: 'include' }),
  tagTypes: ['AccountEmail', 'PhoneStatus'],
  endpoints: build => ({
    getAccountEmail: build.query({
      query: () => ({ url: 'auth/pending-email', method: 'GET' }),
      providesTags: ['AccountEmail'],
    }),
    getPhoneStatus: build.query({
      query: () => ({ url: 'auth/phone-status', method: 'GET' }),
      providesTags: ['PhoneStatus'],
    }),
  }),
});

export const { useGetAccountEmailQuery, useGetPhoneStatusQuery } = accountApi;
export default accountApi.reducer;
